import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CoreLeaseDealsModel, CoreLeaseDealsPaths } from 'client/data/models/core-lease-deals';
import { LEASE_DEALS_PATH } from 'site-modules/shared/constants/lease-deals/routes';
import { addQueryParam } from 'site-modules/shared/utils/url-utils';
import { SOURCES } from 'client/utils/image-helpers';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { ShoppingLink } from 'site-modules/shared/components/shopping-link/shopping-link';
import { Image } from 'site-modules/shared/components/image/image';

const CREATIVE_ID = 'oem_lease_deal';

const LeaseDealsHiddenGemsLinkUI = ({
  className = '',
  make,
  model,
  year,
  isMobile = false,
  parentCreativeId = '',
  bestDeal = undefined,
}) => {
  const monthlyPayment = bestDeal?.payment;
  const paymentMedian = bestDeal?.paymentMedian;

  if (!(monthlyPayment && paymentMedian)) {
    return null;
  }

  const belowAveragePayment = paymentMedian - monthlyPayment;
  const dealDetails =
    belowAveragePayment > 0
      ? `${formatPriceString(belowAveragePayment)} below typical`
      : 'available for a limited time';

  return (
    <ShoppingLink
      label={`${formatPriceString(monthlyPayment)}/mo lease found!`}
      description={`This exceptionally rare deal is ${dealDetails}`}
      to={bestDeal.id ? addQueryParam(LEASE_DEALS_PATH, 'id', bestDeal.id) : LEASE_DEALS_PATH}
      className={classNames('rounded-8 p-1_5 bg-white', className)}
      descriptionClassName="size-14 text-cool-gray-30"
      icon={
        <div
          className="d-flex align-items-center justify-content-center me-0_75 me-md-1_5 rounded-circle bg-turquoise-90"
          style={{
            flexShrink: 0,
            ...(isMobile ? { height: '40px', width: '40px' } : { height: '48px', width: '48px' }),
          }}
        >
          <Image
            lazy
            ariaHidden
            source={SOURCES.STATIC}
            imageId="/icons/lease-deals-gem.svg"
            className="object-fit-cover"
            width={19}
            height={16}
          />
        </div>
      }
      data-tracking-parent={parentCreativeId ? `${parentCreativeId}_${CREATIVE_ID}` : CREATIVE_ID}
      data-tracking-id="view_hidden_gems_lease_deals"
      data-tracking-value={`${formatPriceString(monthlyPayment)} - ${make} ${model} ${year}`}
    />
  );
};

LeaseDealsHiddenGemsLinkUI.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  parentCreativeId: PropTypes.string,
  bestDeal: PropTypes.shape({
    id: PropTypes.string,
    payment: PropTypes.number,
    paymentMedian: PropTypes.number,
  }),
};

export const LeaseDealsHiddenGemsLink = connectToModel(LeaseDealsHiddenGemsLinkUI, {
  bestDeal: bindToPath(
    ({ make, model, year }) => CoreLeaseDealsPaths.getFirstBestPaymentDealMMYPath({ make, model, year }),
    CoreLeaseDealsModel,
    null,
    false
  ),
});

LeaseDealsHiddenGemsLink.propTypes = {
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
};
